import React, { Component } from 'react';
import { observer } from 'mobx-react';
import 'Styles/commonComponents/Table/Pagination.scss';
import IconsContainer from "Utils/IconsContainer";

class PaginationV2 extends Component {
    constructor(props) {
        super(props);
        this.pageInputFocused = false;
        this.state = {
            pageInput: false
        }

        this.handleClickOutside = this.handleClickOutside.bind(this); //todo

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate() {
        if (!this.state.pageInput || this.pageInputFocused) return;

        this.paginationInput.focus();
    }

    handleClickOutside(event) {
        if (this.paginationInfoContainer && !this.paginationInfoContainer.contains(event.target))
            this.closePaginationInput();
    }


    closePaginationInput() {
        this.setState({
            pageInput: false
        });

        this.pageInputFocused = false;
    }

    checkForEnterPress(e) {
        let allow_char = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
        if (allow_char.indexOf(e.which) === -1) {
            e.preventDefault();
        }

        if (e.charCode === 13) {
            if (this.paginationInput.value !== '') {
                if (isNaN(this.paginationInput.value)) {
                    e.preventDefault();
                    this.closePaginationInput();
                    return;
                }
                let paginationInputValueInt = parseInt(this.paginationInput.value);
                let pageToSetInt = paginationInputValueInt;
                if (paginationInputValueInt < 1) {
                    this.paginationInput.value = '1';
                    pageToSetInt = 1;
                }
                else if (paginationInputValueInt > this.pageCount()) {
                    this.paginationInput.value = this.pageCount().toString();
                    pageToSetInt = this.pageCount();
                }

                this.setCurrentPage(pageToSetInt);
            }
            this.closePaginationInput();
        }
    }

    pageCount() {
        return this.props.pageCount > 0 ? this.props.pageCount : 1;
    }
    currentPage() {
        return this.props.currentPage > 0 ? this.props.currentPage : 1;
    }
    setCurrentPage(val) {
        this.props.setCurrentPage(val);
    }

    prevPageEnabled() {
        return this.pageCount() > 1 && this.currentPage() > 1;
    }
    setPageEnabled() {
        return this.pageCount() > 1;
    }
    nextPageEnabled() {
        return this.pageCount() > 1 && this.currentPage() < this.pageCount();
    }

    render() {
        return (
            <div className={"pagination " + this.props.className}>
                <button className={"first-page " + (this.prevPageEnabled() ? '' : 'disabled')}
                    onClick={() => this.setCurrentPage(1)}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-double-arrow-left')}
                    </div>
                </button>
                <button className={"prev-page " + (this.prevPageEnabled() ? '' : 'disabled')}
                    onClick={() => this.setCurrentPage(this.currentPage() - 1)}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-arrow-down')}
                    </div>
                </button>
                <div className={"pagination-info " + (this.setPageEnabled() ? '' : 'disabled')}
                    ref={node => this.paginationInfoContainer = node}
                    onClick={_ => this.setState({ pageInput: true })}>
                    {
                        this.state.pageInput
                            ? (
                                <input
                                    className='pagination-input'
                                    onKeyPress={e => this.checkForEnterPress(e)}
                                    ref={node => this.paginationInput = node} />
                            )
                            : `${this.currentPage()} из ${this.pageCount()}`
                    }
                </div>
                <button className={"next-page " + (this.nextPageEnabled() ? '' : 'disabled')}
                    onClick={() => this.setCurrentPage(this.currentPage() + 1)}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-arrow-down')}
                    </div>
                </button>
                <button className={"last-page " + (this.nextPageEnabled() ? '' : 'disabled')}
                    onClick={() => this.setCurrentPage(this.pageCount())}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-double-arrow-left')}
                    </div>
                </button>
            </div>
        );
    }
}

export default observer(PaginationV2);